function mapOfferToCard(offerList = []) {
  return offerList.map((el) => {
    console.log("🚀 ~ returnofferList.map ~ el:", el)
    let offerObj = {};
    offerObj.id = el.id;
    offerObj.createdAt = el.attributes.createdAt;
    offerObj.division = el.attributes.division ? el.attributes.division : "";

    offerObj.subTitle =
      el.attributes?.creator?.data?.attributes?.name +
      " - " +
      offerObj.division;
    if (offerObj.division === "") {
      offerObj.subTitle = el.attributes?.creator?.data?.attributes?.name;
    }

    if (el.attributes.role === "Jogador") {
      offerObj.title = el.attributes.player_position;
    } else {
      offerObj.title = el.attributes.sub_role;
    }

    return offerObj;
  });
}

module.exports = { mapOfferToCard };
